module.exports = "<div class=\"accordion\" [ngClass]=\" adClass\" [id]=\"accordionID\">\r\n    <ng-content></ng-content>\r\n</div>"